import { useMemo } from 'react';
import { lineChartConfigSelectors } from '../../reducers/lineChartConfigSlice';
import { useAppSelector } from '../../reducers/rootReducer';
import { VECTOR_LINE_CHART_HEIGHT_IN_PERCENT_BASED_ON_VIEWPORT_HEIGHT } from '../constants';
import { lineChartSVGConstants } from '../../components/Vector/mfrchart/constants';

const useExplicitWidthAndHeight = () => {
  const explicitWidthInPixels = useAppSelector(
    lineChartConfigSelectors.selectTimelineWidth,
  );

  const explicitHeightInPixels =
    (VECTOR_LINE_CHART_HEIGHT_IN_PERCENT_BASED_ON_VIEWPORT_HEIGHT / 100) *
    window.innerHeight;

  const actualTimelineWidth = useMemo(() => {
    if (!explicitWidthInPixels) return 0;

    return (
      explicitWidthInPixels -
      lineChartSVGConstants.horizontalOffset / 2 -
      lineChartSVGConstants.lineChartRightOffset -
      10
    );
  }, [explicitWidthInPixels]);

  return {
    explicitWidthInPixels,
    actualTimelineWidth,
    explicitHeightInPixels,
  } as const;
};

export default useExplicitWidthAndHeight;
